import {baseUrl} from "../../requests/NetworkRequestAuth0";

export const emailPasswordOnboardingSignup = (email, password, successMethod, errorMethod) => {
    const params = {
        email: email,
        password: password
    };
    return fetch(baseUrl + "/api/auth/signup/password", fetchConfig(params))
        .then(function (response) {
            //console.log(response);
            //debugger;
            return response.json();
        })
        .then(responseJson => {
            responseJson && successMethod(responseJson)
            return true;
        })
        .catch(error => {
            console.log("ERROR IS");
            console.log(error);
            errorMethod(true);
        });

};

export const signupMobile = (phoneNumber, phoneNumberReadable, successMethod, errorMethod) => {
    const params = {
        phoneNumber: phoneNumber,
        phoneNumberReadable: phoneNumberReadable
    };
    return fetch(baseUrl + "/api/auth/signup/mobile", fetchConfig(params))
        .then(function (response) {
            //console.log(response);
            //debugger;
            return response.json();
        })
        .then(responseJson => {
            responseJson && successMethod(responseJson)
            return true;
        })
        .catch(error => {
            console.log("ERROR IS");
            console.log(error);
            errorMethod(true);
        });

};

export const loginMobile = (phoneNumber, phoneNumberReadable, successMethod, errorMethod) => {
    const params = {
        phoneNumber: phoneNumber,
        phoneNumberReadable: phoneNumberReadable
    };
    return fetch(baseUrl + "/api/auth/signin/mobile", fetchConfig(params))
        .then(function (response) {
            //console.log(response);
            //debugger;
            return response.json();
        })
        .then(responseJson => {
            responseJson && successMethod(responseJson)
            return true;
        })
        .catch(error => {
            console.log("ERROR IS");
            console.log(error);
            errorMethod(true);
        });

};

export const validateEmailAccessCodeOnBoarding = (email, accessCode, successMethod, errorMethod) => {
    const params = {
        email: email,
        accessCode: accessCode
    };
    return fetch(baseUrl + "/api/auth/signup/password/validate", fetchConfig(params))
        .then(function (response) {
            //console.log(response);
            //debugger;
            return response.json();
        })
        .then(responseJson => {
            responseJson && successMethod(responseJson)
            return true;
        })
        .catch(error => {
            console.log("ERROR IS");
            console.log(error);
            errorMethod(true);
        });

};

export const validateMobileAccessCode = (phoneNumber, accessCode, successMethod, errorMethod) => {
    const params = {
        phoneNumber: phoneNumber,
        accessCode: accessCode
    };
    return fetch(baseUrl + "/api/auth/signup/mobile/validate", fetchConfig(params))
        .then(function (response) {
            //console.log(response);
            //debugger;
            return response.json();
        })
        .then(responseJson => {
            responseJson && successMethod(responseJson)
            return true;
        })
        .catch(error => {
            console.log("ERROR IS");
            console.log(error);
            errorMethod(true);
        });

};

export const validateMobileLoginAccessCode = (phoneNumber, accessCode, successMethod, errorMethod) => {
    const params = {
        phoneNumber: phoneNumber,
        accessCode: accessCode
    };
    return fetch(baseUrl + "/api/auth/signin/mobile/validate", fetchConfig(params))
        .then(function (response) {
            //console.log(response);
            //debugger;
            return response.json();
        })
        .then(responseJson => {
            responseJson && successMethod(responseJson)
            return true;
        })
        .catch(error => {
            console.log("ERROR IS");
            console.log(error);
            errorMethod(true);
        });

};

export const emailAccessCodeResendOnboarding = (email, successMethod, errorMethod) => {
    const params = {
        email: email
    };
    return fetch(baseUrl + "/api/auth/signup/password/resend", fetchConfig(params))
        .then(function (response) {
            //console.log(response);
            //debugger;
            return response.json();
        })
        .then(responseJson => {
            responseJson && successMethod(responseJson)
            return true;
        })
        .catch(error => {
            console.log("ERROR IS");
            console.log(error);
            errorMethod(true);
        });

};

export const loginOnboard = (email, password, successMethod, errorMethod) => {
    const params = {
        username: email,
        password: password
    };
    const url = baseUrl + "/api/auth/signin";
    // console.log("URL");
    // console.log(url);
    // console.log("PARAMS");
    // console.log(JSON.stringify(params));
    //return fetch(url, fetchConfig(params));
    return fetch(url, fetchConfig(params))
        .then(function (response) {
            //console.log(response);
            //debugger;
            return response.json();
        })
        .then(responseJson => {
            responseJson && successMethod(responseJson)
            return true;
        })
        .catch(error => {
            // console.log("ERROR IS");
            // console.log(error);
            errorMethod(true);
        });
};

export const loginVenueUser = (venueCode, email, password, successMethod, errorMethod) => {
    const params = {
        venueCode: venueCode,
        username: email,
        password: password
    };
    const url = baseUrl + "/api/auth/venue/user/signin";
    // console.log("URL");
    // console.log(url);
    // console.log("PARAMS");
    // console.log(JSON.stringify(params));
    //return fetch(url, fetchConfig(params));
    return fetch(url, fetchConfig(params))
        .then(function (response) {
            //console.log(response);
            //debugger;
            return response.json();
        })
        .then(responseJson => {
            responseJson && successMethod(responseJson)
            return true;
        })
        .catch(error => {
            // console.log("ERROR IS");
            // console.log(error);
            errorMethod(true);
        });
};



// export const createOnBoardingUrl = (
//     successMethod,
//     errorMethod
// ) => {
//     const params = {};
//     fetchPost(
//         "/api/stripe/createaccount/express",
//         successMethod,
//         errorMethod,
//         params
//     );
// };
//
// export const checkProfileComplete = (
//     successMethod,
//     errorMethod
// ) => {
//     const params = {};
//     fetchPost(
//         "/api/stripe/account/express/complete",
//         successMethod,
//         errorMethod,
//         params
//     );
// };

export const forgotPassword = (email, successMethod, errorMethod) => {
    const params = {
        email: email
    };
    return fetch(baseUrl + "/api/auth/onboard/forgot/password", fetchConfig(params))
        .then(function (response) {
            //console.log(response);
            //debugger;
            return response.json();
        })
        .then(responseJson => {
            responseJson && successMethod(responseJson)
            return true;
        })
        .catch(error => {
            // console.log("ERROR IS");
            // console.log(error);
            errorMethod(true);
        });

};

export const forgotPasswordVenue = (venueCode, username, successMethod, errorMethod) => {
    const params = {
        venueCode: venueCode,
        username: username
    };
    return fetch(baseUrl + "/api/auth/onboard/venue/forgot/password", fetchConfig(params))
        .then(function (response) {
            //console.log(response);
            //debugger;
            return response.json();
        })
        .then(responseJson => {
            responseJson && successMethod(responseJson)
            return true;
        })
        .catch(error => {
            // console.log("ERROR IS");
            // console.log(error);
            errorMethod(true);
        });

};

export const resetPassword = (email, password, cr, rd, successMethod, errorMethod) => {
    const params = {
        email: email,
        password: password,
        cr: cr,
        rd: rd
    };
    return fetch(baseUrl + "/api/auth/onboard/reset/password", fetchConfig(params))
        .then(function (response) {
            //console.log(response);
            //debugger;
            return response.json();
        })
        .then(responseJson => {
            responseJson && successMethod(responseJson)
            return true;
        })
        .catch(error => {
            // console.log("ERROR IS");
            // console.log(error);
            errorMethod(true);
        });

};

const fetchConfig = (myBody = {}) => {
    let httpHeaders = new Headers({});
    httpHeaders.append("Content-Type", "application/json");
//  const timeZoneOffset = (new Date().getTimezoneOffset() / 60) * -1;
//  myHeaders.append("user-timezone-offset", timeZoneOffset);

    return {
        method: "POST",
        headers: httpHeaders,
        //mode: 'cors',
        //cache: "default",
        cache: "no-store",
        body: JSON.stringify(myBody)
    };
};